export { default as ResultRow } from './ResultRow.vue';
export { default as GeneralInformation } from './GeneralInformation';
export { default as GeographicAreas } from './GeographicAreas';
export { default as ProposalRequestDocuments } from './ProposalRequestDocuments';
export { default as ProvidedServices } from './ProvidedServices';
export { default as ProposalDetails } from './ProposalDetails/Main';
export { default as BitacoraManager } from './Bitacora/BitacoraManager';
